<template>
  <div class="stand-ort">
    <h1>Hier finden Sie uns</h1>
    <div class="mapcontainer">
      <h2>{{ praxisData[0].address }}, {{ praxisData[0].name }}</h2>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2637.7037558639518!2d8.476292743746328!3d53.485556965558104!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47b6b9d1824412e3%3A0xa8f8566d745f4121!2sBahnhofstra%C3%9Fe%2051%2C%2026954%20Nordenham%2C%20Germany!5e0!3m2!1sen!2shu!4v1574875138549!5m2!1sen!2shu"
        height="450"
        frameborder="0"
        style="border:0; width: 100%;"
        allowfullscreen=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StandOrt',

  props: {
    praxisData: {
      type: Object,
      required: true,
    }
  }
}
</script>

<style scoped>
.stand-ort {
  background-color: #D8B4A0;
  padding: 30px;
  text-align: center;
}

.mapcontainer {
  width: 500px;
  display: inline-block;
}

@media screen and (max-width: 700px) {
  .mapcontainer {
    width: 100%;
  }
}
</style>